/**
 * When a new service worker is waiting, what should the app do? The rule
 * from the plan: updates apply on the next launch, and never reload the
 * page while field work is waiting to sync.
 *
 * - The update was already waiting in an earlier session (we flagged it) and
 *   the outbox is empty → this is the next launch: apply it now.
 * - Otherwise → remember it for next launch and offer "Restart now", which
 *   is only enabled while nothing is waiting to sync.
 */
export type UpdateAction = "none" | "apply-now" | "offer";

export interface UpdateState {
  /** A new service worker is installed and waiting. */
  waiting: boolean;
  /** An earlier session saw the same waiting update. */
  seenInEarlierSession: boolean;
  /** Unsynced or rejected field items. */
  unsynced: number;
}

export function updateAction(state: UpdateState): UpdateAction {
  if (!state.waiting) return "none";
  if (state.seenInEarlierSession && state.unsynced === 0) return "apply-now";
  return "offer";
}

/** localStorage key: set when an update is seen waiting, cleared once none is. */
export const UPDATE_SEEN_KEY = "sq:sw-update-seen";
